import gql from 'graphql-tag';
export default gql`
  mutation getQuoteDocusign($returnUrl: String!) {
    getQuoteDocusign(returnUrl: $returnUrl) {
      url
    }
  }
`;
